import { render, staticRenderFns } from "./checkout-payment-methods.vue?vue&type=template&id=28323d32&"
import script from "./checkout-payment-methods.vue?vue&type=script&lang=js&"
export * from "./checkout-payment-methods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports